import { httpStatus, retryDelayMs } from '@dawn/core/utils';

/**
 * The throttler's longest block (`RATE_LIMIT_MAX_TTL` in `@dawn/nestjs`, 24 h).
 * Its `Retry-After` is the full block, so waiting it out lets the retry succeed
 * even when a tier is retuned live to a block longer than the 60 s default.
 */
const MAX_RETRY_AFTER_MS = 86_400_000;

/** 400 (no subdomain) or 404 (unknown slug) from the tenant-resolution middleware. */
export function isInvalidTenantError(error: unknown): boolean {
  const status = httpStatus(error);
  return status === 400 || status === 404;
}

/**
 * TanStack `retryDelay` for a 429 (`attempt` is 0-based). Shared with the
 * rate-limit screen so its countdown matches the real wait (TDEV-1107).
 */
export function rateLimitRetryDelay(attempt: number, error: unknown): number {
  return retryDelayMs(attempt, error, MAX_RETRY_AFTER_MS);
}
